<template>
  <div>
    <v-data-table
    dark
      :headers="headers"
      :items="desserts"
    >
      <template v-slot:item.name="props">
        <v-edit-dialog
          :return-value.sync="props.item.name"
          @save="save"
          @cancel="cancel"
          @open="open"
          @close="close"
        > {{ props.item.name }}
          <template v-slot:input>
                <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
            <v-text-field
              v-model="props.item.name"
              :rules="[max25chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.iron="props">
        <v-edit-dialog
          :return-value.sync="props.item.iron"
          large
          persistent
          @save="save"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          <div>{{ props.item.iron }}</div>
          <template v-slot:input>
            <div class="mt-4 title">Update Iron</div>
          </template>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.iron"
              :rules="[max25chars]"
              label="Edit"
              single-line
              counter
              autofocus
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>



<style>

  .project.complete {
      border-left: 4px solid #3cd1c2;
  }
  .project.no {
      border-left: 4px solid orange;
  }
  .project.up {
      border-left: 4px solid red;
  }
  .project.yes {
      border-left: 4px solid yellow;
  }
   .v-chip.complete {
      color: #3cd1c2;
  }
  .p.ovnored {
      color: orange;
  }
  .p.up {
      color:  red;
  }
  .p.yes {
      color:  yellow;
  }

</style>



<script>
  export default {
    data () {
      return {
        snack: false,
        snackColor: '',
        snackText: '',
        max25chars: v => v.length <= 25 || 'Input too long!',
        pagination: {},
        headers: [
          {
            text: 'Account',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Date', value: 'date' },
          { text: 'Amount', value: 'amount' },
          { text: 'Balance', value: 'balance' },
          { text: 'Percentage', value: 'percentage' },
          { text: 'Type', value: 'type' },
        ],
        desserts: [
          {
            name: 'Google',
            date: '06/05/20',
            amount: '$124,143.78',
            balance: '$24,754.45',
            percentage: '85%',
            type: 'Check',
          },
          {
            name: 'Facebook',
            date: '06/03/20',
            amount: '$435,143.78',
            balance: '$57,354.65',
            percentage: '80%',
            type: 'Wire Transfer',
          },
          {
            name: 'Twitter',
            date: '06/03/20',
            amount: '$24,143.78',
            balance: '$16,894.65',
            percentage: '50%',
            type: 'Wire Transfer',
          },
          {
            name: 'SpaceX',
            date: '06/03/20',
            amount: '$36,143.78',
            balance: '$24,754.45',
            percentage: '85%',
            type: 'Check',
          },
          {
            name: 'Amazon',
            date: '06/02/20',
            amount: '$345,769.35',
            balance: '$78,521.91',
            percentage: '90%',
            type: 'Check',
          },
          {
            name: 'Baskin Robbins',
            date: '05/29/20',
            amount: '$185,946.64',
            balance: '$48,327.79',
            percentage: '75%',
            type: 'Check',
          },
          {
            name: 'Walmart',
            date: '05/26/20',
            amount: '$75,286.46',
            balance: '$185,479.35',
            percentage: '63%',
            type: 'Wire Transfer',
          },
          {
            name: 'Starbucks',
            date: '05/25/20',
            amount: '$452,489.35',
            balance: '$784,469.38',
            percentage: '60%',
            type: 'Check',
          },
          {
            name: 'McDonalds',
            date: '05/18/20',
            amount: '$54,143.78',
            balance: '$248,785.96',
            percentage: '50%',
            type: 'Check',
          },
          {
            name: 'nVidia',
            date: '05/18/20',
            amount: '$36,349.24',
            balance: '$146,946.71',
            percentage: '25%',
            type: 'Check',
          },
        ],
      }
    },
    methods: {
      save () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved'
      },
      cancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      open () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      close () {
        console.log('Dialog closed')
      },
    },
  }
</script>


